import React, { useEffect, useState, useRef } from 'react';

const Checkbox = ({
  name,
  updateValueToFilters,
  filterType,
  filterValue,
  appliedFilters,
  SetapplyFilterCheck,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const isPresent =
      appliedFilters &&
      appliedFilters.find(each => each.name === filterType.attr);
    if (isPresent) {
    } else {
      // setIsChecked(false);
    }
    let check = appliedFilters.find(
      each => each.value === filterValue.value && each.name === filterType.attr
    );
    if (check != undefined) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [appliedFilters]);

  const checkRef = useRef();

  return (
    <input
      type="checkbox"
      name={name}
      ref={checkRef}
      checked={isChecked}
      onChange={() => {
        SetapplyFilterCheck(true);
        updateValueToFilters(
          filterType.name,
          filterType.attr,
          filterValue.metaValue,
          filterValue.value,
          filterValue.attribute,
          !isChecked
        );
      }}
    />
  );
};

export default Checkbox;
